export async function waitUntil(condition: () => boolean, time = 1000) {
  while (!condition()) {
    await new Promise(resolve => setTimeout(resolve, time));
  }
}
